import * as React from "react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import { MenuItem, DeleteMenuItem, BootstrapModalConfirm } from "components/bootstrap";
import { Spinner } from "components/common";
import useScopePermissions from "hooks/useScopePermissions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { useDeleteLookupTable } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { MoreActionsMenu } from "components/common/MoreActions";
function Actions({ lut }) {
  const { t } = useTranslation("lookup_tables");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const sendTelemetry = useSendTelemetry("lut");
  const { deleteLookupTable, deletingLookupTable } = useDeleteLookupTable();
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(lut);
  const { push } = useHistory();
  const handleEdit = useCallback(() => {
    push(Routes.SYSTEM.LOOKUPTABLES.edit(lut.name));
  }, [lut, push]);
  const handleDelete = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LUT.DELETED, {
      app_pathname: "lut"
    });
    deleteLookupTable(lut.id).then(() => setShowDeleteModal(false));
  }, [lut.id, sendTelemetry, deleteLookupTable]);
  if (loadingScopePermissions) return /* @__PURE__ */ React.createElement(Spinner, { text: "" });
  if (!scopePermissions.is_mutable) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActionsMenu, { id: lut.id, size: "lg", pullRight: true, title: t("lut_list.more_actions", { name: lut.name }) }, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: handleEdit }, t("lut_list.edit")), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowDeleteModal(true) }, t("lut_list.delete"))), showDeleteModal && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: true,
      title: t("lut_list.delete_title"),
      onCancel: () => setShowDeleteModal(false),
      onConfirm: handleDelete,
      cancelButtonDisabled: deletingLookupTable,
      confirmButtonDisabled: deletingLookupTable,
      confirmButtonText: t("lut_list.delete")
    },
    /* @__PURE__ */ React.createElement("p", null, t("lut_list.delete_confirm", { title: lut.title }))
  ));
}
const renderActions = (lut) => /* @__PURE__ */ React.createElement(Actions, { lut });
function useActions() {
  return {
    renderActions
  };
}
export default useActions;
